export enum MentionFilterTypeEnum {
  Contains = 'contains',
  NotEquals = '!=',
  NotContains = 'not-contains',
  Equals = '='
}

export const MentionFilterTypes = [
  {label: 'operator.contains', value: MentionFilterTypeEnum.Contains},
  {label: 'operator.not-equals', value: MentionFilterTypeEnum.NotEquals},
  {label: 'operator.not-contains', value: MentionFilterTypeEnum.NotContains},
  {label: 'operator.equals', value: MentionFilterTypeEnum.Equals}
];
